{
  "assets": {
    "upload_new": "Charger un nouveau {{ assetType }}"
  },
  "edit_layer": {
    "discard_title": "Modifications non enregistrées",
    "discard_message": "En cliquant sur Oui, vous acceptez d'ignorer toutes les modifications non enregistrées apportées à cette couche. Désirez-vous toujours continuer ?"
  },
  "move": {
    "moveTo": "Déplacer vers cet endroit",
    "setTo": "Définir un nouvel emplacement",
    "tooltip": {
      "Map": "Impossible de passer à un plan",
      "Layer": "Impossible de se déplacer dans une couche"
    },
    "tooltip_self": "Impossible de déplacer un dossier vers lui-même"
  },
  "fixed_shape": {
    "length": "Longueur",
    "width": "Largeur"
  },
  "mapObjectSidebarOptions": {
    "hide_object": "Masquer l'objet",
    "show_object": "Afficher l'objet",
    "hide_group": "Masquer le groupe",
    "show_group": "Afficher le groupe"
  },
  "object_details": {
    "minimise": "Minimiser les détails des objets",
    "edit_attributes": "Gérer les attributs",
    "object_details": "DÉTAILS DE L'OBJET",
    "object_name": "Nom de l'objet"
  },
  "verticalBarErrors": {
    "layer_hidden_drawing": "Vous ne pouvez pas modifier une couche qui est masquée",
    "layer_locked_drawing": "Vous ne pouvez pas modifier une couche verrouillée",
    "hide_layer_composition": "Vous ne pouvez pas masquer une couche pendant que vous la modifiez",
    "group_composition": "Vous ne pouvez pas masquer un groupe lorsque vous modifiez l'une de ses couches"
  },
  "export_map": {
    "export_map": "Plan d'exportation",
    "export_preview": "Aperçu de l'exportation",
    "lock_map": "Verrouiller la fenêtre",
    "orientation": {
      "title": "Orientation de la page",
      "portrait": "Portrait",
      "landscape": "Paysage"
    },
    "page_size": {
      "title": "Taille de page"
    },
    "file_format": {
      "title": "Format de fichier"
    },
    "scale": "Échelle",
    "infoTooltip": {
      "title": "Viewport",
      "text": "Cliquez sur la carte pour faire défiler et ajuster votre fenêtre d'affichage, puis verrouillez la fenêtre pour enregistrer les modifications dans votre éditeur."
    },
    "positionMapOverlay": {
      "title": "Positionnez la carte",
      "text": "Déplacez, zoomez et faites pivoter pour choisir la zone à exporter"
    },
    "read_user_visibility_warning": "Les exportations excluent les changements de visibilité dus aux utilisateurs ne disposant pas de l'autorisation d'accès total à la carte."
  },
  "styles": {
    "customiseColour": "Personnalisez la couleur",
    "scaleText": "Icône d'échelle pour l'adapter au texte",
    "textMargin": "Marge de texte",
    "modelVariableSizeError": "Valeur non valide. Assurez-vous que toutes les valeurs sont comprises entre {{ minValue }} et {{ maxValue }}",
    "dimensions": "Dimensions",
    "customDimensions": "Personnalisez les dimensions des modèles",
    "customColour": "Autoriser la personnalisation de la couleur.",
    "customImage": "Autoriser l'image personnalisée (format d'image facultatif).",
    "widthLengthHeight": "Largeur, longueur, hauteur"
  },
  "permissions": {
    "permission_is": "L'autorisation est",
    "readonly": "en lecture seule",
    "map": "sur plan",
    "layer": "sur une couche",
    "selection": "sur la sélection"
  },
  "layer_overflow": {
    "hidden_text": "Menu de débordement des couches",
    "layer_properties": "Paramètres des couches",
    "attribute_table": "Table attributaire",
    "delete_layer": "Supprimer la couche",
    "layer_view": {
      "display_text": "Vue des couches",
      "view_by_object": "Afficher par objet",
      "view_by_attribute": "Afficher par attribut"
    },
    "remove_from_map": "Supprimer du plan",
    "manage_permissions": "Gérer les autorisations"
  },
  "plan": "Plans",
  "dashboard": "Tableau de bord",
  "units": {
    "feet": "Pieds"
  },
  "controls": {
    "set_pitch": "Inclinez la vue"
  },
  "toolbarButtonTooltips": {
    "helpButton": "Aide",
    "layers": "Retourner aux couches"
  }
}